
import React from "react";
import { Part } from "@/data/parts";
import { useIsMobile } from "@/hooks/use-mobile";
import { Badge } from "@/components/ui/badge";
import PartRating from "@/components/PartRating";
import { ColumnId, SortState } from "../PartTableHeader";

interface NameCellProps {
  part: Part;
  goToPartDetails: () => void;
  onCategoryClick: (category: any) => void;
  onSubcategoryClick: (subcategory: any) => void;
  sortState?: SortState;
  onRatingSort?: (columnId: ColumnId) => void;
}

const NameCell = ({ 
  part, 
  goToPartDetails, 
  onCategoryClick, 
  onSubcategoryClick,
  sortState,
  onRatingSort
}: NameCellProps) => {
  const isMobile = useIsMobile();
  
  // Handle rating click for sorting on mobile
  const handleRatingClick = () => {
    if (isMobile && onRatingSort) {
      onRatingSort("rating");
    }
  };
  
  return (
    <div>
      <div className="flex items-start">
        <div 
          className="cursor-pointer hover:text-primary hover:underline flex-1"
          onClick={goToPartDetails}
        >
          {part.name}
          {part.manufacturer && (
            <span className="text-xs text-muted-foreground ml-2">
              ({part.manufacturer})
            </span>
          )}
        </div>
        
        {/* Show rating icon next to name on mobile */}
        {isMobile && part.subcategory !== "tools" && part.rating > 0 && (
          <div className="flex items-center justify-end ml-2">
            <PartRating 
              rating={part.rating} 
              sidebarExpanded={false}
              onClick={handleRatingClick}
              className="cursor-pointer"
            />
          </div>
        )}
      </div>
      {isMobile && (
        <div 
          className="text-xs text-muted-foreground mt-1 line-clamp-3 cursor-pointer"
          onClick={goToPartDetails} 
        >
          {part.description}
          
          {/* Show category badge in mobile view */}
          <div className="mt-2">
            <Badge 
              variant={part.category === "k1_series" ? "default" : "secondary"}
              className="cursor-pointer hover:opacity-80 transition-opacity mr-2"
              onClick={(e) => {
                e.stopPropagation();
                onCategoryClick(part.category);
              }}
            >
              {part.category === "k1_series" ? "K1" : part.category === "k2_series" ? "K2" : "TOOLS"}
            </Badge>
            
            <span 
              className="text-xs cursor-pointer hover:text-primary"
              onClick={(e) => {
                e.stopPropagation();
                onSubcategoryClick(part.subcategory);
              }}
            >
              {part.subcategory}
            </span>
          </div>
        </div>
      )}
      {!isMobile && (
        <div 
          className="text-xs text-muted-foreground mt-1 line-clamp-3 cursor-pointer"
          onClick={goToPartDetails} 
        >
          {part.description}
        </div>
      )}
    </div>
  );
};

export default NameCell;
